import { FORM_ASSIGNMENTS_STATUS } from "@/types/entities/formality-request";

import { Button, Icon, RowCard } from "@elaniintc/goes-design-system";
import { NavLink, useParams } from "react-router";
import { getBadge } from "../form-badges";
import type { ApiFlowsExecutionsResponseType } from "@/types/entities/flows";
import dayjs from "dayjs";
import { useMemo } from "react";

export const SingCard = ({
  node,
  procedureId,
  index,
}: {
  node: ApiFlowsExecutionsResponseType["data"][number]["node_executions"][number];
  procedureId: string;
  index: number;
}) => {
  const params = useParams<{
    procedureId: string;
    id?: string;
    registryId?: string;
  }>();
  const badge = getBadge(node.status as keyof typeof FORM_ASSIGNMENTS_STATUS);
  const isPending = node.status === FORM_ASSIGNMENTS_STATUS.PENDING;
  const startedAt = dayjs(node.started_at).format("DD/MM/YYYY HH:mm A");

  const redirectUrl = useMemo(() => {
    if (params.id && params.registryId) {
      return `/expedientes/entidad/${params.id}/detalle-registro/${params.registryId}`;
    }
    return `/tramite`;
  }, [params]);

  return (
    <>
      <NavLink to={`${redirectUrl}/${procedureId}/firma/${node.id}`}>
        <RowCard
          key={node.id ?? index}
          title={
            <p className="font-normal text-base text-body-loud truncate leading-tight">
              {node.node.display_name}
            </p>
          }
          color={(() => {
            if (isPending) return "info";
            if (node?.status === FORM_ASSIGNMENTS_STATUS.COMPLETED) {
              return "success";
            }
            return "action";
          })()}
          icon={{
            name: "signature",
            type: "fas",
            size: "lg",
          }}
          subtitle={`Iniciado ${startedAt}`}
        >
          <RowCard.Right>
            {badge}
            <Button
              onClick={() => console.log(node)}
              variant="ghost"
              size="xs"
              className="size-8"
            >
              <Icon type="far" name="arrow-up-right" />
            </Button>
          </RowCard.Right>
        </RowCard>
      </NavLink>
    </>
  );
};
